import { render, staticRenderFns } from "./OptionInput.vue?vue&type=template&id=6dce6f46"
import script from "./OptionInput.vue?vue&type=script&lang=ts"
export * from "./OptionInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports